module.exports = __webpack_public_path__ + "img/53.3.TP.7773544a.png";